module.exports = __webpack_public_path__ + "static/media/agg_rata.eb626e80.png";